/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";

/**
 * useImageLoadedForUpload is used with a files array to populate the width and
 * height of the files in the array
 * @param refs
 * @param files
 * @returns {{loaded: boolean, onLoad: onLoad}}
 */

const useImageLoadedForUpload = (refs, files) => {

    // const [loaded, setLoaded] = useState(false)

    // keep an index and access refs via refs.current[n]

    const onLoad = (file, index) => {

        file.width = refs.current[index].naturalWidth;
        file.height = refs.current[index].naturalHeight;
        URL.revokeObjectURL(file.preview);
        
    };

    useEffect(() => {
        refs.current = refs.current.slice(0, files.length);
    }, [files, refs]);

    return { onLoad, refs };
};

export { useImageLoadedForUpload };
